define(function(require) {
  /* ----------------------------------- [ Consts ] ----------------------------------- */
  var APPLICATION_TYPE = 'lpSuggestionsController';
  var NEGATIVE = 'negative';
  var POSITIVE = 'positive';
  var agentLEManager = require('web-agent-utils/agentLEManager');
  var Logger = require('logger');
  var logger = Logger.getLogger(APPLICATION_TYPE);

  /* ----------------------------------- [ Static ] ----------------------------------- */

  SuggestionsController.applicationType = APPLICATION_TYPE;

  /* ---------------------------------- [ Privates ] ---------------------------------- */

  var model = null; // the application model.
  var coreAIIntentDomain = null;
  var coreAIFeedbackDomain = null;
  var agentId = null;
  var accountId = null;
  var handleSuggestion = null;
  var handleFeedback = null;
  var handleErrorCallback = null;

  /* ------------------------------- [ Class Definition ] ------------------------------- */

  function SuggestionsController(applicationModel) {
    model = applicationModel;
  }

  /**
   * Initializes the values needed for the suggestion functions
   */
  SuggestionsController.prototype.initialize = function(data) {
    // Get domains from CSDS
    coreAIIntentDomain = agentLEManager.getLEUrlResolverGetUrl(
      '{coreAIIntent}'
    );
    coreAIFeedbackDomain = agentLEManager.getLEUrlResolverGetUrl(
      '{coreAIFeedback}'
    );

    // Assign values to variables from data
    agentId = data && data.agentId;
    accountId = data && data.accountId;
    handleFeedback = data && data.handleFeedback;
    handleSuggestion = data && data.handleSuggestion;
    handleErrorCallback = data && data.handleErrorCallback;
  };

  /**
   * Gets the active suggestions from the set of provided items
   */
  SuggestionsController.prototype.getActiveSuggestions = function(items) {
    // Filter out disposed views that are not suggestions
    if (items.length) {
      return items.filter(function(item) {
        // Dispose of non-visible items
        if (!item.visible && typeof item.dispose === 'function') {
          item.dispose();
        }

        // Return only SuggestionViewControllers that are not disposed and visible
        return (
          item.ControllerName === 'SuggestionViewController' &&
          !item.disposed &&
          item.visible
        );
      });
    }
    return [];
  };

  /**
   * Gets the unread chats from the visitor only, not the agent
   */
  SuggestionsController.prototype.getVisitorChatsWithoutState = function(
    data,
    messageState
  ) {
    if (data && data.newValue) {
      return data.newValue.filter(function(chat) {
        var isUnread = chat && chat.status !== messageState;
        var isChatFromVistor = chat && chat.source === 'visitor';
        return isChatFromVistor && isUnread;
      });
    }
    return [];
  };

  /**
   * Find the text in the dropdown items list and return the enumValue
   */
  SuggestionsController.prototype.getFeedbackEnum = function(
    feedbackItems,
    text
  ) {
    var feedbackItem = _.find(feedbackItems, function(item) {
      return item.textValue && item.textValue === text;
    });
    return feedbackItem ? feedbackItem.enumValue : undefined;
  };

  /**
   * Parse the score into a text value to be translated
   */
  SuggestionsController.prototype.parseScore = function(score) {
    var textScore = 'ai_assist_score_low';
    if (score >= 0.5) {
      textScore = 'ai_assist_score_medium';
    }
    if (score >= 0.7) {
      textScore = 'ai_assist_score_high';
    }
    return textScore;
  };

  /**
   * Fetches the suggestions from the intent service and returns the one with the highest score
   */
  SuggestionsController.prototype.fetchSuggestions = function(chat) {
    var body = {
      msgId: chat && chat.id,
      convId: chat && chat.conversationId,
      brandId: accountId,
      text: chat && chat.text
    };

    postToUrl(
      coreAIIntentDomain + '/api/v1/message',
      body,
      handleSuggestionSuccess.bind(null, chat),
      handleSuggestionError
    );
  };

  /**
   * Sends positive feedback to the feedback service
   */
  SuggestionsController.prototype.sendPositiveFeedback = function(data) {
    sendFeedback({
      value: (data && data.value) || POSITIVE,
      chat: data && data.chat,
      suggestion: data && data.suggestion,
      visitorId: data && data.visitorId
    });
  };

  /**
   * Sends negative feedback to the feedback service
   */
  SuggestionsController.prototype.sendNegativeFeedback = function(data) {
    sendFeedback({
      value: NEGATIVE,
      text: data && data.text,
      reason: data && data.reason,
      chat: data && data.chat,
      suggestion: data && data.suggestion,
      visitorId: data && data.visitorId
    });
  };

  /**
   * Handles action success logging
   */
  SuggestionsController.prototype.handleActionSuccess = function() {
    logger.info('Suggestion action success');
  };

  /**
   * Handles action error logging
   */
  SuggestionsController.prototype.handleActionError = function() {
    logger.error('Suggestion action error');
  };

  /* ------------------------------ [ private functions ] ------------------------------ */

  var postToUrl = function(url, body, handleSuccess, handleError) {
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
      xhr.setRequestHeader(
        'Authorization',
        'Bearer ' + agentLEManager.getGlobLE()
      );
      xhr.setRequestHeader('user-id', agentId);
      xhr.setRequestHeader('account-id', accountId);
      xhr.onload = function() {
        if (
          xhr.readyState === 4 &&
          (xhr.status === 204 || xhr.status === 200)
        ) {
          handleSuccess(xhr);
        } else {
          handleError(
            new Error('invalid status code: ' + xhr.status + ' for url ' + url)
          );
        }
      };
      xhr.onerror = function() {
        handleError(new Error('xhr error'));
      };
      xhr.send(JSON.stringify(body));
    } catch (error) {
      logger.error('XMLHttpRequest failure:', error);
    }
  };

  var sendFeedback = function(data) {
    var body = {
      suggestionId: data && data.suggestion && data.suggestion.id,
      messageId: data && data.chat && data.chat.id,
      conversationId: data && data.chat && data.chat.conversationId,
      agentId: agentId,
      visitorId: data && data.visitorId,
      brandId: accountId,
      feedbackText: data && data.text,
      feedbackReason: data && data.reason,
      feedbackValue: data && data.value
    };

    postToUrl(
      coreAIFeedbackDomain + '/v1/feedback',
      body,
      handleFeedbackSuccess,
      handleFeedbackError
    );
  };

  var handleSuggestionSuccess = function(chat, data) {
    try {
      var suggestions = data ? JSON.parse(data.responseText) : [];

      if (suggestions.length) {
        // Sort the suggestions by score
        suggestions.sort(function(a, b) {
          return b.score - a.score;
        });

        // handle the sugestion with the highest score
        handleSuggestion(chat, suggestions[0]);
      }
    } catch (error) {
      handleSuggestionError(error);
    }
  };

  var handleFeedbackSuccess = function() {
    if (handleFeedback) {
      handleFeedback();
    }
    logger.info('Feedback successfully sent');
  };

  var handleSuggestionError = function(error) {
    if (handleErrorCallback) {
      handleErrorCallback(error);
    }
    logger.error('Suggestion error:', error);
  };

  var handleFeedbackError = function(error) {
    if (handleErrorCallback) {
      handleErrorCallback(error);
    }
    logger.error('Feedback error:', error);
  };

  /* ******************************************** */

  return SuggestionsController;
});
